var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCameraSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_767_2140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.23047 4.5202C1.23047 3.65934 1.92833 2.96148 2.78919 2.96148C3.23647 2.96148 3.63356 2.67527 3.77501 2.25094L3.82662 2.0961C3.85096 2.02308 3.86313 1.98656 3.87615 1.95418C4.04242 1.54059 4.43204 1.25977 4.87698 1.23282C4.91182 1.23071 4.95031 1.23071 5.02728 1.23071H8.97212C9.04909 1.23071 9.08758 1.23071 9.12242 1.23282C9.56736 1.25977 9.95698 1.54059 10.1232 1.95418C10.1363 1.98656 10.1484 2.02308 10.1728 2.0961L10.2244 2.25094C10.3658 2.67527 10.7629 2.96148 11.2102 2.96148C12.0711 2.96148 12.7689 3.65934 12.7689 4.5202V9.42302C12.7689 10.3923 12.7689 10.877 12.5803 11.2472C12.4144 11.5729 12.1496 11.8377 11.8239 12.0036C11.4537 12.1923 10.969 12.1923 9.9997 12.1923H3.9997C3.03038 12.1923 2.54572 12.1923 2.17549 12.0036C1.84982 11.8377 1.58505 11.5729 1.41911 11.2472C1.23047 10.877 1.23047 10.3923 1.23047 9.42302V4.5202Z",
    stroke: "#667085",
    strokeWidth: 1.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9997 9.5961C8.43352 9.5961 9.59585 8.43376 9.59585 6.99994C9.59585 5.56613 8.43352 4.40379 6.9997 4.40379C5.56588 4.40379 4.40355 5.56613 4.40355 6.99994C4.40355 8.43376 5.56588 9.5961 6.9997 9.5961Z",
    stroke: "#667085",
    strokeWidth: 1.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_767_2140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.8462,
    height: 13.8462,
    fill: "white",
    transform: "translate(0.0761719 0.0769043)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCameraSmall);
export default __webpack_public_path__ + "static/media/IconCameraSmall.35cbbe9682a03831a45d80aa331498fe.svg";
export { ForwardRef as ReactComponent };